export const historyAction  = {
    push: 'PUSH',
    pop: 'POP',
};
